import React, { Component } from "react";
import styled from "styled-components";

const StyledFooter = styled.footer`
  width: 100%;
  height: 18rem;
  p {
    font-size: 1.8rem;
    padding-top: 2.4rem;

    &.small {
      font-size: 1.4rem;
      line-height: 2rem;
      padding-top: 0;
    }
  }
`;

class Footer extends Component {
  state = {};
  render() {
    return (
      <StyledFooter>
        <p>© 2020 Kay Products - all rights reserved</p>
        <p className="small">
          Kay Products is the trading name of Kay Products Ltd, registered in
          England and Wales under company number 12251744.
        </p>
      </StyledFooter>
    );
  }
}

export default Footer;
